import { Omit } from '@40seas/entities/common';
import { TenantlessBaseEntityFieldsArray } from '@40seas/models';
import { Tenant } from './tenant.entity';

export class CreateTenantDto extends Omit(Tenant, TenantlessBaseEntityFieldsArray) {}
